import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import { useReactToPrint } from "react-to-print";
import {
  Button,
  Checkbox,
  Fab,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CboProfesionales } from "../../cbos/CboProfesionales";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  agendaLimpiar,
  cancelarTurno,
  confirmarAsistenciaTurno,
  confirmarBajaTurnos,
  consultaPacientesEnEspera,
  consultaPacientesEnSala,
  exportExcelRecepDiaria,
  fetchPagoTurno,
  fetchTurnosTomadosPorFecha,
  generarEstudioMedicoRecepcion,
  generatePdfRecepDiaria,
  getAutopercepcionPorAfiliado,
  TurnosTomadosPorFechaLimpiar
} from "../../../actions/turnos/agenda";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { fetchMotivosBajaTurno } from "../../../actions/turnos/motivosBajaTurno";
import {
  efectorHorariosLimpiar,
  fetchEfectorHorariosPorProfesionalFecha,
} from "../../../actions/turnos/efectorHorarios";
import { ModalAltaTurnoDemanda } from "./ModalAltaTurnoDemanda";
import { TableToolbarExportAndPrint } from "./TableToolbarExportAndPrint";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { TURNOS_PERMISOS } from "../../../utils/permisos";
import { HorariosLicenciasProfesional } from "./HorariosLicenciasProfesional";
import {
  fetchlicenciasProfesionales,
  licenciasProfesionalesLimpiar,
} from "../../../actions/turnos/licenciasProfesionales";
import { ModalCoseguro } from "../coseguros/ModalCoseguro";
import { ModalDevolucionMonto } from "./ModalDevolucionMonto";
import { CENTROS_MEDICOS_PROPIOS, OBRAS_SOCIALES, TIPO_TURNO } from "../../../utils/constants";
import CosegurosService from "../../../services/CosegurosService";
import { handleErrorApi } from "../../../helpers/randoms";
import { postAnularComprobantePorCancelacion } from "../../../actions/coseguros/coseguros";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import PracticasHandler from "./PracticasHandler";
import ConsultaPracticas from "./ConsultaPracticas";
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { ModalPisoConsultorio } from "./ModalPisoConsultorio";
import { ModalDatosAfiliado } from "./ModalDatosAfiliado";
import { seleccionAfiliado } from "../../../actions/afiliado";
import { Edit, LibraryBooksSharp, PrintSharp } from "@material-ui/icons";
import { ModalMensajeAfiliado } from "./ModalMensajeAfiliado";
import { ImpresionTicketOsocna } from "./ImpresionTicketOsocna";
import { ModalOpciones } from '../../shared/ModalOpciones';
import { ModalTurnoDemandaLaboratorio } from './laboratorio/ModalTurnoDemandaLaboratorio';
import { changeStepper } from '../../../actions/preAfiliado/stepper';
import { ModalPacientesEnSala } from "./ModalPacientesEnSala";
import { laboratorioClear } from '../../../actions/turnos/laboratorio';

const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
  keyBoardArroy: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#80808047",
      borderRadius: "2rem",
    },
  },
});

const stateInitial = {
  idProfesional: null,
  selectedDate: new Date(),
};

const transformDay = (day) => {
  switch (day) {
    case 0:
      return "DO";
    case 1:
      return "LU";
    case 2:
      return "MA";
    case 3:
      return "MI";
    case 4:
      return "JU";
    case 5:
      return "VI";
    case 6:
      return "SA";
    default:
      return null;
  }
};

export const RecepcionDiaria = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { items, cargada } = useSelector((state) => state.agenda);
  const { items: motivosBajaItems, cargada: motivosBajaCargados } = useSelector(
    (state) => state.motivosBajaTurno
  );
  const {
    items: licenciasProfesionalItems,
    cargada: licenciasProfesionalCargadas,
  } = useSelector((state) => state.licenciasProfesionales);
  const { itemsDemanda: horariosItemsDemanda, cargada: horariosItemsCargadas } =
    useSelector((state) => state.efectorHorarios);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const [formValues, handleInputChange, , setearValor] = useForm(stateInitial);
  const { idProfesional, selectedDate } = formValues;
  const [horariosDemandaValidos, setHorariosDemandaValidos] = useState([]);

  const [openCancelar, setOpenCancelar] = useState(false);
  const [openConfirmar, setOpenConfirmar] = useState(false);
  //const [openEmail, setOpenEmail] = useState(false);
  //const [mailAfi, setMailAfi] = useState('');
  const [open, setOpen] = useState(false);
  const [turnoSelec, setTurnoSelec] = useState();
  const [confirmado, setConfirmado] = useState(false);
  const [idMotivoCancelacion, setIdMotivoCancelacion] = useState();
  const [openModalCoseguro, setOpenModalCoseguro] = useState(false);
  const [openModalDatosAfiliado, setOpenModalDatosAfiliado] = useState(false);
  const [openModalPracticas, setOpenModalPracticas] = useState(false);
  const [openOptionsDemanda, setOpenOptionsDemanda] = useState(false);
  const [openPracticasHandler, setOpenPracticasHandler] = useState(false);
  const [openDemandaLaboratorio, setOpenDemandaLaboratorio] = useState(false);
  const [openModalPisoConsultorio, setOpenModalPisoConsultorio] = useState(false);
  const [usuarioTurnoSeleccionado, setUsuarioTurnoSeleccionado] = useState(null);
  const [displayModalDevolucionMonto, setDisplayModalDevolucionMonto] = useState(false);
  const [importeParaDevolucion, setImporteParaDevolucion] = useState(0);
  const [desdeBotonAux, setDesdeBotonAux] = useState(false);
  const [idObraSocial, setIdObraSocial] = useState(OBRAS_SOCIALES.OSPEDYC);
  const [openModalAfiliado, setOpenModalAfiliado] = useState(false);
  const [marca, setMarca] = useState(false);
  const [openModalImpresion, setOpenModalImpresion] = useState(false);
  const [infoImpresion, setInfoImpresion] = useState(null);
  const [openPacienteEnSala, setOpenPacienteEnSala] = useState(false);

  const permisoGenerarEstudio = validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.BANDEJA_ESTUDIOS_MEDICOS)


  useEffect(() => {
    dispatch(agendaLimpiar());
    dispatch(efectorHorariosLimpiar());
    dispatch(licenciasProfesionalesLimpiar());
  }, [dispatch]);

  useEffect(() => {
    if (!motivosBajaCargados) {
      dispatch(fetchMotivosBajaTurno());
    }
  }, [dispatch, motivosBajaCargados]);

  useEffect(() => {
    if (!openModalDatosAfiliado) {
      if (selectedDate && idProfesional !== null) {
        dispatch(fetchTurnosTomadosPorFecha(selectedDate.toISOString(), idProfesional));
        if (idProfesional === -1) {
          dispatch(efectorHorariosLimpiar());
          dispatch(licenciasProfesionalesLimpiar());
        } else {
          idProfesional &&
            dispatch(
              fetchEfectorHorariosPorProfesionalFecha(
                idProfesional,
                selectedDate.toISOString(),
                true
              )
            );
          idProfesional &&
            dispatch(fetchlicenciasProfesionales(null, idProfesional, null));
        }
      } else {
        dispatch(TurnosTomadosPorFechaLimpiar());
        dispatch(efectorHorariosLimpiar());
        dispatch(licenciasProfesionalesLimpiar());
      }
    }
  }, [dispatch, idProfesional, selectedDate, openModalDatosAfiliado]);

  const handleOpenCancelarTurno = (turno) => {
    setTurnoSelec(turno);
    setOpenCancelar(true);
  };

  const handleSendCancelarTurno = () => {
    if (turnoSelec.sobreTurno)
      dispatch(confirmarBajaTurnos([turnoSelec.idAgenda], idMotivoCancelacion));
    else
      dispatch(cancelarTurno(turnoSelec.idAgenda, idMotivoCancelacion));
    resetValues();
    setOpenCancelar(false);
  };

  const handleOpenConfirmarAsistencia = (turno, checked) => {
    setDesdeBotonAux(false);
    setTurnoSelec(turno);
    setConfirmado(checked);
    setInfoImpresion(turno);
    if (
      checked &&
      !turno.especialidad.exentoCoSeguro &&
      turno.centroMedico.idCentroMedico !== CENTROS_MEDICOS_PROPIOS.ESCOBAR &&
      turno.idTipoTurnoSol === TIPO_TURNO.PRESENCIAL
    ) {
      dispatch(
        fetchPagoTurno(
          turno.idAgenda,
          setTurnoSelec,
          turno,
          () => addedPracticasAndAbonar(turno),
          () => setOpenConfirmar(true)
        )
      );
    } else {
      setOpenConfirmar(true);
    }
  };

  const addedPracticasAndAbonar = (turno) => {
    setUsuarioTurnoSeleccionado(turno);
    setOpenModalCoseguro(true);
  }

  const closeOpenConfirmarHandler = () => {
    setOpenConfirmar(false);
  };

  const handleSendConfirmarAsistencia = async (confirmado) => {
    resetValues();
    setUsuarioTurnoSeleccionado(turnoSelec);
    setOpenConfirmar(false);

    if (
      !confirmado ||
      turnoSelec?.previamenteAbonado ||
      turnoSelec.especialidad.exentoCoSeguro ||
      turnoSelec.centroMedico.idCentroMedico ===
      CENTROS_MEDICOS_PROPIOS.ESCOBAR ||
      turnoSelec.idTipoTurnoSol === TIPO_TURNO.VIRTUAL
    ) {
      if (
        !confirmado &&
        !turnoSelec.especialidad.exentoCoSeguro &&
        !(
          turnoSelec.centroMedico.idCentroMedico ===
          CENTROS_MEDICOS_PROPIOS.ESCOBAR
        ) &&
        !(turnoSelec.idTipoTurnoSol === TIPO_TURNO.VIRTUAL)
      ) {
        try {
          dispatch(startSpinner());
          const response = await CosegurosService.getHabilitarDevolucionMonto(
            turnoSelec.idAgenda
          );
          const data = await response.json();
          if (!response.ok) {
            throw data;
          } else {
            const { adeuda, importeDevolucion } = data;
            if (adeuda) {
              const dataPost = {
                idAgenda: turnoSelec.idAgenda,
                nroLote: null,
                nroCupon: null,
                importeDevuelto: null,
              };

              dispatch(
                postAnularComprobantePorCancelacion(
                  dataPost,
                  closeOpenConfirmarHandler,
                  confirmarAsistenciaTurno,
                  turnoSelec.idAgenda
                )
              );
            } else {
              setDisplayModalDevolucionMonto(!adeuda);
              setImporteParaDevolucion(importeDevolucion);
            }
            dispatch(finishSpinner());
          }
        } catch (error) {
          dispatch(finishSpinner());
          handleErrorApi(
            dispatch,
            error,
            "Error al consultar por devolución de monto.",
            "Ha ocurrido un error. Intente nuevamente"
          );
        }
      } else {
        dispatch(confirmarAsistenciaTurno(turnoSelec.idAgenda, confirmado));
      }
    }
  };

  const handleCloseAlert = () => {
    resetValues();
    setConfirmado(false);
    setOpenCancelar(false);
    setOpenConfirmar(false);
  };

  const handleInputChangeMotivo = ({ target }) => {
    setIdMotivoCancelacion(target.value);
  };

  const resetValues = () => {
    setTurnoSelec();
    setIdMotivoCancelacion();
  };

  const closeModalUpdateAfiliado = () => {
    setOpenModalDatosAfiliado(false)
    setIdMotivoCancelacion();
  };

  useEffect(() => {
    if (
      idProfesional &&
      licenciasProfesionalCargadas &&
      horariosItemsCargadas
    ) {
      const horaActual = moment({
        hour: moment().hour(),
        minute: moment().minute(),
      });
      const horariosItemsDemandaFiltrado = horariosItemsDemanda.filter(
        (s) => s.dia === transformDay(moment(selectedDate).day())
      );

      const horariosConDiferencia = horariosItemsDemandaFiltrado.map((i) => {
        const diffDesde = moment
          .duration(
            moment({ hour: i.horaDesde, minute: i.minDesde }).diff(horaActual)
          )
          .asMinutes();
        const diffHasta = moment
          .duration(
            moment(horaActual).diff({ hour: i.horaHasta, minute: i.minHasta })
          )
          .asMinutes();

        return {
          ...i,
          tieneLicencia: licenciasProfesionalItems
            .filter(
              (s) =>
                s.idCm === i.idCentro && s.idEspecialidad === i.idEspecialidad
            )
            .filter((s) => !s.fecProCBaja)
            .filter((s) =>
              moment(moment(selectedDate).format("YYYY-MM-DD")).isBetween(
                moment(s.fechaDesde).format("YYYY-MM-DD"),
                moment(s.fechaHasta).format("YYYY-MM-DD"),
                undefined,
                "[]"
              )
            ).length
            ? true
            : false,
          diferenciaDesdeMinutos: diffDesde,
          diferenciaHastaMinutos: diffHasta,
        };
      });

      const horariosValidos = horariosConDiferencia
        .filter(
          (s) =>
            s.diferenciaDesdeMinutos <= 30 && s.diferenciaHastaMinutos <= 60
        )
        .filter((s) => !s.tieneLicencia);
      setHorariosDemandaValidos(horariosValidos);
    } else {
      setHorariosDemandaValidos([]);
    }
  }, [
    horariosItemsDemanda,
    selectedDate,
    idProfesional,
    licenciasProfesionalItems,
    licenciasProfesionalCargadas,
    horariosItemsCargadas,
  ]);

  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleGeneratePdf = () => {
    // TODO add filters
    dispatch(generatePdfRecepDiaria(selectedDate.toISOString(), idProfesional));
  };

  const handleExportExcel = () => {
    // TODO add filters
    dispatch(
      exportExcelRecepDiaria(
        selectedDate.toISOString(),
        idProfesional,
        moment().format("YYYY-MM-DD")
      )
    );
  };

  const closeModalCoseguroHandler = () => {
    setOpenModalCoseguro(false);
    if (infoImpresion?.afiliadoExterno?.idObraSocial === OBRAS_SOCIALES.OSOCNA) {
      setOpenModalImpresion(true);
    }
  };


  const closeModalPracticasHandler = () => {
    setOpenModalPracticas(false);
    setOpenPracticasHandler(false);
    setUsuarioTurnoSeleccionado(null);
  };

  const closeModalDevolucionMontoHandler = () => {
    setDisplayModalDevolucionMonto(false);
  };

  const onClickShowMenuPracticasHandler = (
    item,
    modalidad = "CONSULTA_PRACTICA"
  ) => {
    setTurnoSelec(item);
    setUsuarioTurnoSeleccionado(item);
    if (modalidad === "ADD_PRACTICA") {
      setOpenModalCoseguro(true);
      setDesdeBotonAux(true);
    } else {
      setOpenModalPracticas(true);
    }
  };

  const closeModalMensajeAfiliado = () => {
    setOpenModalAfiliado(false);
    handleOpenConfirmarAsistencia(
      usuarioTurnoSeleccionado,
      marca
    )
  };

  return (
    <React.Fragment>
      {openModalImpresion && (
        <ImpresionTicketOsocna
          open={openModalImpresion}
          onClose={setOpenModalImpresion}
          infoImpresion={infoImpresion}
          idObraSocial={idObraSocial}
        />
      )}
      {openModalAfiliado && (
        <ModalMensajeAfiliado
          open={openModalAfiliado}
          onClose={closeModalMensajeAfiliado}
          setOpenPracticasHandler={setOpenPracticasHandler}
          usuarioTurnoSeleccionado={usuarioTurnoSeleccionado}
        />
      )}
      {openModalCoseguro && (
        <ModalCoseguro
          fecha={selectedDate}
          open={openModalCoseguro}
          idProfesional={idProfesional}
          openDemandaLaboratorio={openDemandaLaboratorio}
          setOpenDemandaLaboratorio={setOpenDemandaLaboratorio}
          onClose={closeModalCoseguroHandler}
          setOpenPracticasHandler={setOpenPracticasHandler}
          usuarioTurnoSeleccionado={usuarioTurnoSeleccionado}
          desdeBotonAux={desdeBotonAux}
          idObraSocial={usuarioTurnoSeleccionado?.afiliadoExterno?.idObraSocial}
          infoImpresion={infoImpresion}
          setInfoImpresion={setInfoImpresion}
          cargaDefaultPractica={false}
        />
      )}
      {displayModalDevolucionMonto && (
        <ModalDevolucionMonto
          open={displayModalDevolucionMonto}
          onClose={closeModalDevolucionMontoHandler}
          usuarioTurnoSeleccionado={usuarioTurnoSeleccionado}
          monto={importeParaDevolucion}
          idAgenda={usuarioTurnoSeleccionado?.idAgenda}
          idObraSocial={usuarioTurnoSeleccionado?.afiliadoExterno?.idObraSocial}
        />
      )}
      {openModalPracticas && (
        <ConsultaPracticas
          open={openModalPracticas}
          onClose={closeModalPracticasHandler}
          idAgenda={usuarioTurnoSeleccionado?.idAgenda}
          fecha={usuarioTurnoSeleccionado?.fecha}
        />
      )}
      {openModalDatosAfiliado && (
        <ModalDatosAfiliado
          open={openModalDatosAfiliado}
          onClose={() => closeModalUpdateAfiliado()}
          idObraSocial={idObraSocial}
        />
      )

      }
      {/* <DialogEmail
        open={openEmail}
        handleClose={() => setOpenEmail(false)}
        email={mailAfi}
      /> */}
      <Grid container className={classes.root} justify="center" spacing={1}>
        <Grid item xs={11}>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={12} md={5}>
              <Paper className={classes.input}>
                <CboProfesionales
                  manejadorInputChange={handleInputChange}
                  filtrarPorUsuario={true}
                  conEspecialidad={true}
                  valor={idProfesional}
                  autocomplete={true}
                  showAll={true}
                />
              </Paper>
            </Grid>
            {idProfesional && (
              <Grid item xs={12} md={2}>
                <Paper
                  className={classes.input}
                  style={{
                    textAlign: "center",
                    marginLeft: 10,
                    marginRight: 10
                  }}
                >
                  {openPacienteEnSala &&
                    <ModalPacientesEnSala
                      open={openPacienteEnSala}
                      setOpen={setOpenPacienteEnSala}
                      fecha={selectedDate}
                      title={"Pacientes en sala"}
                      idEfectorRed={idProfesional}
                    />
                  }
                  <Button
                    variant="contained"
                    onClick={() => {
                      dispatch(consultaPacientesEnSala(idProfesional, selectedDate));
                      dispatch(consultaPacientesEnEspera(idProfesional, selectedDate));
                      setOpenPacienteEnSala(true)
                    }
                    }
                    disabled={
                      !validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.ALTA)
                    }
                    color="primary"
                  >
                    Pacientes en Sala
                  </Button>
                </Paper>
              </Grid>
            )}
            <Grid item xs={12} md={!idProfesional ? 4 : 2}>
              <Paper
                className={classes.input}
                style={{
                  textAlign: "center",
                  display: horariosDemandaValidos.length > 0 ? "block" : "none",
                }}
              >
                {idProfesional && (
                  <ModalAltaTurnoDemanda
                    open={open}
                    setOpen={setOpen}
                    fecha={selectedDate}
                    title={"Alta Nuevo Turno Por Demanda"}
                    horariosDemandaValidos={horariosDemandaValidos}
                  />
                )}
                {idProfesional && openOptionsDemanda &&
                  <ModalOpciones
                    open={openOptionsDemanda}
                    title={"Opciones Turno Demanda"}
                    opciones={[
                      // 'DEMANDA',
                      'DEMANDA LABORATORIO'
                    ]}
                    onCloseModal={() => setOpenOptionsDemanda(false)}
                    onChoseOption={(option) => {
                      if (option === 0) {
                        setOpen(true)
                      }
                      else {
                        dispatch(laboratorioClear())
                        setOpenDemandaLaboratorio(true)
                        dispatch(changeStepper(0))
                      }
                      setOpenOptionsDemanda(false)
                    }}
                  />
                }
                {openDemandaLaboratorio &&
                  <ModalTurnoDemandaLaboratorio
                    fecha={selectedDate}
                    open={openDemandaLaboratorio}
                    title={"Ingreso de Prácticas Laboratorio"}
                    horariosDemandaValidos={horariosDemandaValidos}
                    addedPracticasAndAbonar={addedPracticasAndAbonar}
                    onCloseModal={() => setOpenDemandaLaboratorio(false)}
                  />
                }
                <Button
                  variant="contained"
                  onClick={() => {
                    if(horariosDemandaValidos.filter(s => s.especialidad.practicasDemanda).length > 0){
                      // setOpenOptionsDemanda(true)
                      dispatch(laboratorioClear())
                      setOpenDemandaLaboratorio(true)
                      dispatch(changeStepper(0))
                    }
                    else {
                      setOpen(true);
                    }
                  }}
                  disabled={
                    !validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.ALTA)
                  }
                  color="primary"
                >
                  Turno Por Demanda
                </Button>
              </Paper>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={12} md={2}>
              <Paper className={classes.input}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha"
                    format="dd/MM/yyyy"
                    required={true}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(selectedDate).isValid() ? moment(selectedDate) : 0
                    }
                    onChange={(date) => {
                      setearValor("selectedDate", date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        {idProfesional && (
          <Grid item xs={11}>
            <Grid container direction="row" alignItems="center">
              <HorariosLicenciasProfesional
                title={"Horarios / Licencias"}
                idProfesional={idProfesional}
              />
            </Grid>
          </Grid>
        )}
        <Grid item xs={11}>
          <TableContainer component={Paper}>
            <Table ref={componentRef}>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Afiliado</TableCell>
                  <TableCell align="left">N° Afiliado</TableCell>
                  <TableCell align="left">Hora</TableCell>
                  <TableCell align="left">Sobre Turno</TableCell>
                  <TableCell align="left">Centro Médico</TableCell>
                  <TableCell align="left">Profesional</TableCell>
                  <TableCell align="left">Especialidad</TableCell>
                  <TableCell align="left">Modalidad</TableCell>
                  <TableCell align="center">Asiste</TableCell>
                  <TableCell align="left"></TableCell>
                  {(process.env.REACT_APP_COLOR_BAR === 'test' ||
                    process.env.REACT_APP_COLOR_BAR === 'development') &&
                    <TableCell align="center">Llamador</TableCell>
                  }
                  <TableCell align="center"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.length > 0 ? (
                  items.map((item) => (
                    <TableRow key={item.idAgenda}>
                      <TableCell
                        align="left"
                        style={(item.afiliado?.fecha_baja || item.afiliadoExterno?.fechaBaja) ? { color: "red" } : item.afiliado?.sinFichaAfiliacion ? { color: "orange" } : { color: "black" }}
                      >
                        {item.afiliado?.fecha_baja && `AFILIADO DE BAJA - `}
                        {item.afiliado?.sinFichaAfiliacion && `AFILIADO CON COBERTURA SUSPENDIDA - `}
                        {`${(item.afiliado?.apellido_y_nombre || item.afiliadoExterno?.apellidoNombre)} / Tel: ${(item.afiliado?.domiciliosAfiliados?.celular || item.afiliadoExterno?.domiciliosAfiliados?.celular)} / ${(item.afiliado?.domiciliosAfiliados?.telefono || item.afiliadoExterno?.domiciliosAfiliados?.telefono)}`}
                        <Tooltip
                          //title={item.afiliado?.domiciliosAfiliados?.mail || item.afiliadoExterno?.domiciliosAfiliados?.mail} 
                          title={"Actualizar datos de Afiliado"}
                          style={{ boxShadow: 'none', borderRadius: 'unset', backgroundColor: 'unset', height: 'unset', width: 'unset', marginLeft: 10 }}
                        >
                          <Fab onClick={() => {
                            //setOpenEmail(true);
                            //setMailAfi(item.afiliado?.domiciliosAfiliados?.mail || item.afiliadoExterno?.domiciliosAfiliados?.mail);
                            if (item?.afiliado !== null) {
                              setOpenModalDatosAfiliado(true)
                              setIdObraSocial(OBRAS_SOCIALES.OSPEDYC);
                              dispatch(seleccionAfiliado(item?.afiliado));
                              dispatch(getAutopercepcionPorAfiliado(item?.afiliado?.id_afiliado));
                            } else {
                              const afiliadoExterno = {
                                id_afiliado: item?.afiliadoExterno.idAfiliadoExterno,
                                idObraSocial: item?.afiliadoExterno.idObraSocial,
                                apellido_y_nombre: item?.afiliadoExterno.apellidoNombre,
                                carnet: item?.afiliadoExterno.carnet,
                                parent: item?.afiliadoExterno.parent,
                                fecha_nacimiento: item?.afiliadoExterno.fechaNacimiento,
                                fecha_baja: item?.afiliadoExterno.fechaBaja,
                                nro_doc: item?.afiliadoExterno.nroDocumento,
                                domiciliosAfiliados: item?.afiliadoExterno.domiciliosAfiliados
                              };
                              console.log(afiliadoExterno);
                              setOpenModalDatosAfiliado(true)
                              setIdObraSocial(item?.afiliadoExterno.idObraSocial);
                              dispatch(seleccionAfiliado(afiliadoExterno));
                            }

                          }}>
                            <Edit /* style={{fontSize: 30}} */ />
                          </Fab>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="left">
                        {item.afiliado?.carnet || item.afiliadoExterno?.carnet}
                      </TableCell>
                      <TableCell align="left">{item.hora}</TableCell>
                      <TableCell align="left">
                        {item.sobreTurno ? "Si" : "No"}
                      </TableCell>
                      <TableCell align="left">
                        {item.centroMedico?.descripcionCentro}
                      </TableCell>
                      <TableCell align="left">
                        {item.efectorRed?.nombreEfector}
                      </TableCell>
                      <TableCell align="left">
                        {item.especialidad?.descripcionEspecialidades}
                      </TableCell>
                      <TableCell align="left">
                        {item.idTipoTurnoSol === 1 ? "Presencial" : "Virtual"}
                      </TableCell>
                      <TableCell>
                        <FormControlLabel
                          style={{ marginLeft: 2, marginRight: 0 }}
                          control={
                            <Checkbox
                              name="presencial"
                              checked={item.confirmado}
                              disabled={(
                                (!moment(selectedDate).isSame(
                                  moment(),
                                  "day"
                                ) ||
                                  !validarSoloUnPermiso(
                                    permisosUser,
                                    TURNOS_PERMISOS.ASISTENCIA
                                  )) &&
                                // (!item.confirmado || !validarSoloUnPermiso(
                                !validarSoloUnPermiso(
                                  permisosUser,
                                  TURNOS_PERMISOS.PERMITE_CANCELAR_ASISTENCIA_SIN_MIRAR_FECHA
                                )) || (item?.afiliado?.fecha_baja === null ? false : item?.afiliadoExterno?.fechaBaja === null ? false : true)
                              }
                              onChange={(e) => {
                                setUsuarioTurnoSeleccionado(item)
                                if (item?.afiliado?.sinFichaAfiliacion === true) {
                                  setOpenModalAfiliado(true)
                                  setMarca(e.target.checked)
                                }
                                else {
                                  handleOpenConfirmarAsistencia(
                                    item,
                                    e.target.checked
                                  )
                                }
                              }}
                            />
                          }
                        />
                        {item.confirmado && (
                          <PracticasHandler
                            item={item}
                            mostrarButtonConsulta={true}
                            mostrarButtonAdd={item.confirmado}
                            openPracticasHandler={openPracticasHandler}
                            onClickAdd={onClickShowMenuPracticasHandler}
                            setOpenPracticasHandler={setOpenPracticasHandler}
                            onClickConsultar={onClickShowMenuPracticasHandler}
                            usuarioTurnoSeleccionado={usuarioTurnoSeleccionado}
                            setUsuarioTurnoSeleccionado={setUsuarioTurnoSeleccionado}
                          />
                        )}
                      </TableCell>
                      <TableCell align="left" style={{ padding: 12 }}>
                        <Button
                          style={{ marginLeft: -2 }}
                          variant="contained"
                          onClick={() => handleOpenCancelarTurno(item)}
                          disabled={
                            item.confirmado ||
                            moment(selectedDate).isBefore(moment(), "day") ||
                            !validarSoloUnPermiso(
                              permisosUser,
                              TURNOS_PERMISOS.CANCELAR
                            )
                          }
                          color="primary"
                        >
                          Cancelar
                        </Button>
                      </TableCell>
                      {(process.env.REACT_APP_COLOR_BAR === 'test' ||
                        process.env.REACT_APP_COLOR_BAR === 'development') && item.confirmado && item.idTipoTurnoSol === 1 &&
                        <TableCell align="center">
                          {item.consultorio === ''
                            ?
                            <>
                              <Tooltip title="Set Consultorio y Piso">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => { setOpenModalPisoConsultorio(true) }}
                                >
                                  <MeetingRoomIcon /> Test
                                </Button>
                              </Tooltip>
                              <ModalPisoConsultorio
                                open={openModalPisoConsultorio}
                                closeAlertModal={() => { setOpenModalPisoConsultorio(false) }}
                                turno={item}
                              />
                            </>
                            :
                            <>
                              <h6>{`Piso: ${item.piso} / Consultorio: ${item.consultorio}`}</h6>
                            </>

                          }

                        </TableCell>
                      }
                      {item.confirmado && item?.afiliadoExterno?.idAfiliadoExterno &&
                        <TableCell align="left" style={{ padding: 12 }}>
                          <IconButton
                            style={{ marginLeft: -2 }}
                            variant="contained"
                            onClick={() => {
                              setOpenModalImpresion(true);
                              setInfoImpresion(item);
                            }}
                            disabled={item.confirmado ? false : true}
                            color="primary"
                          >
                            <PrintSharp />
                          </IconButton>
                        </TableCell>
                      }
                      {item.confirmado && permisoGenerarEstudio &&
                        <TableCell align="left" style={{ padding: 12 }}>
                          <IconButton
                            title="Generar Estudio"
                            style={{ marginLeft: -2 }}
                            variant="contained"
                            onClick={() => {
                             dispatch(generarEstudioMedicoRecepcion(item?.idAgenda))
                            }}
                            disabled={item.confirmado ? false : true}
                            color="primary"
                          >
                            <LibraryBooksSharp />
                          </IconButton>
                        </TableCell>
                      }
                    </TableRow>

                  ))
                ) : (
                  <TableRow style={{ height: 50 }}>
                    <TableCell
                      colSpan={8}
                      style={{ textAlign: "-webkit-center" }}
                    >
                      {" "}
                      Sin Registros
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={10}>
          <Grid item container>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              {cargada && (
                <TableToolbarExportAndPrint
                  cargada={cargada}
                  handlePrint={handlePrint}
                  handleGeneratePdf={handleGeneratePdf}
                  handleExportExcel={handleExportExcel}
                />
              )}
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </Grid>
        {openCancelar && (
          <AlertFinalizadoStepper
            open={openCancelar}
            pregunta={"Cancelación de Turno"}
            dialogText={`Quiere proceder con la Cancelación del Turno de ${turnoSelec?.afiliado?.apellido_y_nombre || turnoSelec?.afiliadoExterno?.apellidoNombre}?`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Continuar"}
            showComboDialog={true}
            itemsCombo={motivosBajaItems}
            labelCombo={"Motivo"}
            idCombo={"idMotivoBajaTurno"}
            manejadorInputChange={handleInputChangeMotivo}
            valor={idMotivoCancelacion}
            handleClose={handleCloseAlert}
            handleSend={handleSendCancelarTurno}
          />
        )}
        {openConfirmar && (
          <AlertFinalizadoStepper
            open={openConfirmar}
            pregunta={`${confirmado ? "Confirmar" : "Anular"
              } Asistencia al Turno ${turnoSelec?.previamenteAbonado ? " - Previamente Abonado" : ""}`}
            dialogText={`Quiere proceder con la ${confirmado ? "Confirmación" : "Anulación"
              } de Asistencia al turno de ${turnoSelec?.afiliado?.apellido_y_nombre || turnoSelec?.afiliadoExterno?.apellidoNombre
              }?`}
            buttonCancel={"Cancelar"}
            buttonSubmit={`${confirmado ? "Confirmar" : "Anular"}`}
            handleClose={handleCloseAlert}
            handleSend={handleSendConfirmarAsistencia.bind(this, confirmado)}
          />
        )}
      </Grid>
    </React.Fragment>
  );
};
